export class ApplicationTitleHolderApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTitleHolders({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/titleholder`);
  }

  async createTitleHolder({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.post(`/application/${applicationId}/titleholder`, body, {
      params: { withLoanOptionId },
    });
  }

  async editTitleHolder({ applicationId, titleHolderId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/titleholder/${titleHolderId}`, body, {
      params: { withLoanOptionId },
    });
  }

  async deleteTitleHolder({ applicationId, titleHolderId, ...params }) {
    return this.#http.delete(`/application/${applicationId}/titleholder/${titleHolderId}`, {
      params,
    });
  }
}
